import { useQuery } from '@tanstack/react-query';
import type { PublicAffirmation } from '@lighthouse/shared';
import { api } from '../../services/api';

export function DailyAffirmationTeaser() {
  const { data, isLoading } = useQuery({
    queryKey: ['public-affirmation-today'],
    queryFn: () => api.get<PublicAffirmation | null>('/site/affirmation/today'),
    staleTime: 60 * 60_000,
  });

  if (isLoading) {
    return (
      <div className="affirmation-teaser card animate-pulse p-6">
        <div className="h-3 w-32 rounded bg-gray-200" />
        <div className="mt-4 h-4 w-full rounded bg-gray-200" />
      </div>
    );
  }

  if (!data) return null;

  return (
    <blockquote className="affirmation-teaser card p-6 text-center">
      <p className="text-primary-600 text-xs font-bold uppercase tracking-widest">
        Today&apos;s affirmation
      </p>
      <p className="mt-3 text-lg font-medium leading-relaxed text-gray-900 sm:text-xl">
        &ldquo;{data.text}&rdquo;
      </p>
      {data.author ? <footer className="mt-3 text-sm text-gray-500">— {data.author}</footer> : null}
    </blockquote>
  );
}
